import React from "react";
import PageHeading from "../UI/PageHeading";
import {
  Button,
  Heading,
  Flex,
  Text,
  Box,
  Image,
  Link,
  LinkBox,
  LinkOverlay,
} from "@chakra-ui/react";
import { ExternalLinkIcon } from "@chakra-ui/icons";

const transakUrl = process.env.REACT_APP_TRANSAK_URL;
const moonpayUrl = process.env.REACT_APP_MOONPAY_URL;

import transakLogo from "../../media/logos/transak-logo.svg";
import moonpayLogo from "../../media/logos/moonpay-logo.svg";

const OnRampPage = (): JSX.Element => {
  return (
    <>
      <PageHeading title="Fiat Onramps" />
      <Box
        pb="48px"
        pt="48px"
        maxW="728px"
        display="flex"
        justifyContent="flex-start"
        flexDir={{ base: "column", md: "row" }}
      >
        <Box
          mt="8"
          mb="12"
          minW={{ md: "380px" }}
          maxW="430px"
          bg="white"
          border="1px"
          borderColor="brand.300"
          p="8"
          mx="24px"
        >
          <Flex align="center">
            <Heading fontSize="24px" mr="2">
              Buy DAI on Palm with
            </Heading>
            <img alt="Moonpay logo" width="128x" src={moonpayLogo} />
          </Flex>
          <Text mt="8" mb="12">
            MoonPay offers a fast and easy way to buy $DAI on Palm using a
            credit or debit card, bank transfer, Apple Pay, Google Pay or
            another payment method. Over 150 countries supported.
          </Text>
          <LinkBox pt={"24px"}>
            <LinkOverlay href={moonpayUrl} isExternal>
              <Button h="48px" w="234px" leftIcon={<ExternalLinkIcon />}>
                Buy DAI Now&nbsp;
                <Image
                  src="moonpay-icon.svg"
                  boxSize="25px"
                  alt="Moonpay logo"
                />
              </Button>
            </LinkOverlay>
          </LinkBox>
          <Text fontSize="xs" mt="12">
            This service is subject to MoonPay&#39;s{" "}
            <Link
              isExternal
              style={{ textDecoration: "underline" }}
              href="https://www.moonpay.com/legal/terms_of_use"
            >
              terms of use and privacy policy
            </Link>
            . Transaction fees and purchase limits may apply, KYC required.
            Onramp service not offered in all jurisdictions. For assistance in
            using this service, please{" "}
            <Link
              isExternal
              style={{ textDecoration: "underline" }}
              href="https://support.moonpay.com/"
            >
              view support information or raise a ticket
            </Link>
            .
          </Text>
        </Box>

        <Box
          mt="8"
          mb="12"
          minW={{ md: "380px" }}
          maxW="430px"
          bg="white"
          border="1px"
          borderColor="brand.300"
          p="8"
          mx="24px"
        >
          <Flex align="center">
            <Heading fontSize="24px" mr="2">
              Buy DAI on Palm with
            </Heading>
            <img alt="Transak logo" width="96x" src={transakLogo} />
          </Flex>
          <Text mt="8" mb="12">
            While having a global coverage, Transak can help you buy $DAI on
            Palm with 75 currencies and more than 28 local payment methods
            including credit/debit cards, Apple Pay and Google Pay. You will
            receive $DAI directly in your wallet within minutes.
          </Text>
          <LinkBox>
            <LinkOverlay href={transakUrl} isExternal>
              <Button h="48px" w="234px" leftIcon={<ExternalLinkIcon />}>
                Buy DAI Now&nbsp;
                <Image
                  src="transak-icon.svg"
                  boxSize="25px"
                  alt="Transak logo"
                />
              </Button>
            </LinkOverlay>
          </LinkBox>
          <Text fontSize="xs" mt="12">
            This service is subject to Transak&#39;s{" "}
            <Link
              isExternal
              style={{ textDecoration: "underline" }}
              href="https://transak.com/terms-of-service"
            >
              terms
            </Link>
            . Transaction fees and purchase limits may apply, KYC required.
            Onramp service not offered in all jurisdictions. For assistance in
            using this service, please{" "}
            <Link
              isExternal
              style={{ textDecoration: "underline" }}
              href="https://support.transak.com/hc/en-us"
            >
              view support information
            </Link>{" "}
            or{" "}
            <Link
              isExternal
              style={{ textDecoration: "underline" }}
              href="https://support.transak.com/hc/en-us/requests/new"
            >
              raise a ticket
            </Link>
            .
          </Text>
        </Box>
      </Box>
    </>
  );
};
export default OnRampPage;
